var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 161,
    viewBox: "0 0 162 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6427 29.357C79.7057 13.1549 115.645 22.7849 131.848 50.8478C148.05 78.9107 138.42 114.851 110.357 131.053C82.2938 147.255 46.3541 137.625 30.1519 109.562C13.9498 81.4989 23.5798 45.5591 51.6427 29.357Z",
    fill: "url(#paint0_linear_147_2874)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0569 95.1042C58.1536 93.6427 56.1356 92.0931 54.1462 90.5768C51.9499 88.9029 51.5264 85.7655 53.2003 83.5693C54.8742 81.373 58.0116 80.9496 60.2079 82.6235C62.2831 84.2051 64.3026 85.756 66.1901 87.2056C68.2387 88.7789 70.1319 90.2328 71.7721 91.4771C72.2441 91.8351 72.6864 92.1691 73.0965 92.4768C81.8436 82.6548 84.6356 79.3648 90.9815 71.8869C93.2324 69.2345 95.9304 66.0552 99.4998 61.8708C101.292 59.7699 104.448 59.5195 106.549 61.3117C108.65 63.1038 108.9 66.2597 107.108 68.3606C103.563 72.5166 100.874 75.6847 98.6245 78.3357C91.6358 86.571 88.8829 89.815 77.8452 102.176C76.9108 103.368 75.6871 103.843 74.8439 104.005C73.5044 104.263 72.4287 103.89 72.2521 103.829C72.2452 103.826 72.2397 103.824 72.2356 103.823C71.6556 103.628 71.1873 103.353 71.0363 103.264L71.0292 103.26C70.5954 103.006 70.0961 102.665 69.6305 102.336C68.65 101.644 67.293 100.631 65.7285 99.4442C64.1039 98.2118 62.1498 96.7113 60.0569 95.1042Z",
    fill: "white",
    fillOpacity: 0.9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_2874",
    x1: 129.483,
    y1: 118.083,
    x2: 13.5449,
    y2: 55.9434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CAB04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1DAD04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#1DB004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#28B707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#32BE0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#39C30C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#41C70E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#59D115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#71DA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#79DE1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#81E21B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8CE715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97EB0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7b4a2a63c5c12cdd1c19b2ad012aea8a.svg";
export { ForwardRef as ReactComponent };